import { createFileRoute, redirect } from "@tanstack/react-router";
import { AppShell } from "@/components/layouts/AppShell";
import { supabase } from "@/lib/supabase";
import { env } from "@/lib/env";

export const Route = createFileRoute("/_authenticated")({
  // Single source of truth for auth + whitelist. Defense in depth:
  // server-side RLS (`web_owner_read`) is the real boundary.
  beforeLoad: async () => {
    const { data } = await supabase.auth.getSession();
    const email = data.session?.user?.email?.toLowerCase() ?? null;
    const allowed = env.VITE_ALLOWED_EMAIL.toLowerCase();
    if (!data.session) {
      throw redirect({ to: "/login" });
    }
    if (email !== allowed) {
      throw redirect({ to: "/login", search: { error: "not_whitelisted" } });
    }
  },
  component: AppShell,
});
